export const privacyPolicyUrl = 'https://www.ecgo.co/agreements/app-terms';
export const appTermsUrl = 'https://www.ecgo.co/agreements/privacy-policy';
export const androidAppLink =
  'https://play.google.com/store/apps/details?id=com.conserve.ecgo_mobile&hl=en_US';
export const iosAppLink = 'https://apps.apple.com/us/app/ecgo/id1638181650';
